export const formatTimeSlotLocal = (time: string): string | null => {
	const parseTime = (timeStr: string) => ({
		hours: parseInt(timeStr.substring(0, 2), 10),
		minutes: parseInt(timeStr.substring(2), 10),
	});

	const now = new Date();
	const date = new Date(now);
	const { hours: startHours, minutes: startMins } = parseTime(time);
	date.setHours(startHours, startMins, 0, 0);

	const formatTime = (date: Date) =>
		date.toLocaleTimeString([], {
			hour: '2-digit',
			minute: '2-digit',
			hour12: false,
		});
	return formatTime(date);
};
